import React, { useState } from 'react'
import './Employee.css'
import employeeImg from '../../asset/main-slider/employee.avif'

const Employee = () => {
  const [isImageLoaded, setIsImageLoaded] = useState(false)

  return (
    <section className="employee">
      <div className="employee__inner">
        <div className="employee__card">
          <div
            className={`employee__skeleton img-skeleton ${isImageLoaded ? 'is-hidden' : ''}`}
            aria-hidden="true"
          />
          <img
            className={`employee__image img-fade-in ${isImageLoaded ? 'is-loaded' : ''}`}
            src={employeeImg}
            alt="Сотрудник автосервиса"
            loading="lazy"
            onLoad={() => setIsImageLoaded(true)}
          />
          <div className="employee__overlay" />
          <div className="employee__content">
            <h2 className="employee__title">
              Почему наши сотрудники такие крутые?
            </h2>
            <p className="employee__text">
              Наш подбор сотрудников очень прост и понятен – мы работаем только с теми, кто любит то, что делает!
            </p>
            <p className="employee__text">
              Только 1 из 20 соискателей проходят отбор в нашу команду.
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Employee
